import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { get_category } from "./store/reducers/homeReducer";
import SellerWrapper from "./components/SellerWrapper";
import NotFound from "./pages/NotFound";
import GlobalSearch from "./pages/GlobalSearch";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function App() {
  //const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(get_category());
  // }, [dispatch]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/search-products/:searchValue" element={<GlobalSearch />} />
          <Route path="/admin/*" element={<SellerWrapper isAdmin={true} />} />
          <Route path="/:sellerName/*" element={<SellerWrapper isAdmin={false} />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
        <FloatingWhatsApp />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
